module.exports = __webpack_public_path__ + "img/erp-logos_0032_freshbooks.21b649da.jpg";